import React from 'react';
import {Create, SimpleForm, TextInput, NumberInput, Toolbar, SaveButton} from 'react-admin';

const CashbackConditionsCreateToolbar = props => (
    <Toolbar {...props}>
        <SaveButton
            label="save"
            redirect="list"
            submitOnEnter={true}
        />
    </Toolbar>
);

class CashbackConditionsCreate extends React.Component {
    render() {
        return (
            <Create {...this.props}>
                <SimpleForm toolbar={<CashbackConditionsCreateToolbar />}>
                    <TextInput source="margin" label="Margin" fullWidth />
                    <TextInput source="fontSize" label="Font Size" fullWidth />
                    <NumberInput source="position" label="Position" />
                </SimpleForm>
            </Create>
        );
    }
}

export default CashbackConditionsCreate;
